import { GenericFallbacksWrapper } from '../../../components/Fallback/GenericFallbacksWrapper';
import { usePeopleData } from '../hooks/usePeopleData';
import { NoDataMessage2 } from '../components/Messages/HelpMessage';
import { CPWrapper } from '../components/CompanyProfilesWrapper';
import { EmployeeGrids } from './EmployeeGrids';
import { PeopleFilters } from './PeopleFilters';

export const CompanyProfilesPeople = () => {
  const { allPeople } = usePeopleData();

  if (!allPeople?.length) {
    return <NoDataMessage2 />;
  }

  return (
    <CPWrapper>
      <GenericFallbacksWrapper>
        <PeopleFilters />
        <EmployeeGrids />
      </GenericFallbacksWrapper>
    </CPWrapper>
  );
};
